import { $themeConfig } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    layout: {
      isRTL: $themeConfig.layout.isRTL,
      skin: sessionStorage.getItem('vuexy-skin') || $themeConfig.layout.skin,
      routerTransition: sessionStorage.getItem('routerTransition') || $themeConfig.layout.routerTransition,
      // type: $themeConfig.layout.type,
      type: sessionStorage.getItem('layoutType') || $themeConfig.layout.type,
      contentWidth: $themeConfig.layout.contentWidth,
      menu: {
        hidden: $themeConfig.layout.menu.hidden,
      },
      navbar: {
        type: $themeConfig.layout.navbar.type,
        backgroundColor: sessionStorage.getItem('backgroundColor') || $themeConfig.layout.navbar.backgroundColor,
        // backgroundColor: $themeConfig.layout.navbar.backgroundColor,
      },
      footer: {
        type: sessionStorage.getItem('footer') || $themeConfig.layout.footer.type,
      },
    },
  },
  getters: {},
  mutations: {
    TOGGLE_RTL(state) {
      state.layout.isRTL = !state.layout.isRTL
      document.documentElement.setAttribute('dir', state.layout.isRTL ? 'rtl' : 'ltr')
    },
    UPDATE_SKIN(state, skin) {
      state.layout.skin = skin

      // Update value in sessionStorage
      sessionStorage.setItem('vuexy-skin', skin)

      // Update DOM for dark-layout
      if (skin === 'dark') document.body.classList.add('dark-layout')
      else if (document.body.className.match('dark-layout')) document.body.classList.remove('dark-layout')
    },
    UPDATE_ROUTER_TRANSITION(state, val) {
      state.layout.routerTransition = val

      sessionStorage.setItem('routerTransition', val)
    },
    UPDATE_LAYOUT_TYPE(state, val) {
      state.layout.type = val

      sessionStorage.setItem('layoutType', val)
    },
    UPDATE_CONTENT_WIDTH(state, val) {
      state.layout.contentWidth = val
    },
    UPDATE_NAV_MENU_HIDDEN(state, val) {
      state.layout.menu.hidden = val
    },
    UPDATE_NAVBAR_CONFIG(state, obj) {
      Object.assign(state.layout.navbar, obj)

      sessionStorage.setItem('backgroundColor', obj.backgroundColor)
    },
    UPDATE_FOOTER_CONFIG(state, obj) {
      Object.assign(state.layout.footer, obj)

      sessionStorage.setItem('footer', obj.type)
    },
  },
  actions: {},
}
